import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import DialogDeleteIcon from './DialogDeleteIcon'

class AusbilderTerminEditDialog extends React.Component {
  closeDialog = evt => {
    const {closed} = this.props
    closed(evt)
  }

  onDeleteTermin = async () => {
    this.props.deleteTermin({terminId: this.props.id})
    this.closeDialog()
  }

  render() {
    return (
      <div className="ausbilderTerminEditDialog">
        <DialogDeleteIcon
          id={this.props.id}
          onConfirm={this.onDeleteTermin}
          type="ausbilderTermin"
          gruppenId={this.props.gruppenId}
          subject={this.props.subject}
        />
      </div>
    )
  }
}

function mapDispatchToProps() {
  return {
    deleteTermin: actions.versetzungsplan.deleteTermin,
    readVersetzungsplanTermine: actions.versetzungsplan.readVersetzungsplanTermine,
  }
}

export default connect(mapDispatchToProps)(AusbilderTerminEditDialog)

AusbilderTerminEditDialog.propTypes = {
  deleteTermin: PropTypes.func,
  readVersetzungsplanTermine: PropTypes.func,
  closed: PropTypes.func,
  gruppenId: PropTypes.string,
  subject: PropTypes.string,
  id: PropTypes.string,
}
